import { render, staticRenderFns } from "./_.vue?vue&type=template&id=7a8a1feb"
import script from "./_.vue?vue&type=script&lang=js"
export * from "./_.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageCategory: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/page/PageCategory.vue').default,PagePage: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/page/PagePage.vue').default,PageForm: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/page/PageForm.vue').default,PageBlog: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/page/PageBlog.vue').default,PageArticle: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/page/PageArticle.vue').default,UtilityFooter: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/utility/UtilityFooter.vue').default,SnippetFrame: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/snippets/SnippetFrame.vue').default})
